import { Component, OnInit, ViewChild } from '@angular/core';
import { LogoTesterComponent } from 'src/app/modules/programs/components/logo-tester/logo-tester.component';
import { ProgramsService } from '@core/services/programs/programs.service';

/**
 * A diferencia de Strive/Price Simulator (calculadoras sin estado), el Flow
 * de Logo (LOGO_TOKEN) SÍ depende de un programa concreto: el backend exige
 * `program_id` en /logos/submit y las preguntas se toman de
 * `program.logo_questions`. Por eso este tab primero pide elegir un programa
 * con `logo_test_enabled` y luego reutiliza el mismo `app-logo-tester` que ya
 * se usa dentro de "Crear/Editar Programa".
 */
@Component({
  selector: 'app-logo-flow-tester',
  templateUrl: './logo-flow-tester.component.html',
  styleUrls: ['./logo-flow-tester.component.scss'],
})
export class LogoFlowTesterComponent implements OnInit {
  public programs: { id: string; program_name: string }[] = [];
  public selectedProgramId: string = '';
  public loading = false;
  public errorMessage = '';

  @ViewChild(LogoTesterComponent) logoTester?: LogoTesterComponent;

  constructor(private programsService: ProgramsService) {}

  ngOnInit(): void {
    this.loadProgramsWithLogoEnabled();
  }

  loadProgramsWithLogoEnabled(): void {
    this.loading = true;
    this.errorMessage = '';
    this.programsService
      .getListProgramsPaginate(1, 200, { logo_test_enabled: true })
      .subscribe(
        (resp: any) => {
          this.loading = false;
          this.programs = resp?.results?.data || [];
        },
        (err) => {
          this.loading = false;
          this.errorMessage =
            'No se pudieron cargar los programas con generación de logos activa.';
          console.error(err);
        },
      );
  }

  onProgramChange(): void {
    // app-logo-tester no implementa ngOnChanges: al cambiar el @Input programId
    // hay que forzar manualmente la recarga de su historial.
    setTimeout(() => this.logoTester?.loadLogos());
  }
}
